module.exports = __webpack_public_path__ + "img/img4.2944dbb9.svg";